// Font Awesome Vue Component Custom Library

// Font Awesome Icons
// https://fontawesome.com/icons

// Font Awesome Vue Component
// https://github.com/FortAwesome/vue-fontawesome

// fontawesome
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown'
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown'
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp'
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes'
import { faSortDown } from '@fortawesome/pro-duotone-svg-icons/faSortDown'
import { faSortUp } from '@fortawesome/pro-duotone-svg-icons/faSortUp'

export default {
  faAngleDown,
  faAngleRight,
  faArrowRight,
  faCaretDown,
  faCaretUp,
  faTimes,
  faSortDown,
  faSortUp
}
